/* eslint-disable */
import {
  mdiViewDashboard,
  mdiAccountAlert,
  mdiBusDoubleDecker,
  mdiAccountArrowLeft,
  mdiAccountArrowLeftOutline,
  mdiFaceAgent,
  mdiAccountCircle,
  mdiAccountGroup,
  mdiSchool,
  mdiBookOpenVariant,
  mdiBookshelf,
  mdiBookOpenPageVariant,
  mdiBookPlusMultiple,
  mdiHammerScrewdriver,
  mdiFormatListBulletedType,
  mdiFormatLetterMatches,
  mdiNumeric9BoxMultiple,
  mdiNotebookEdit,
  mdiAccountDetails,
  mdiTimetable,
  mdiCalendarMonth,
  mdiTimelineClockOutline,
  mdiPuzzle,
  mdiConsoleNetworkOutline,
  mdiSoccer,
  mdiClipboardAccount,
  mdiClipboardAccountOutline,
  mdiQrcodeScan,
  mdiRunFast,
  mdiTrophyOutline,
  mdiClipboardText,
  mdiAccount,
  mdiAccountCheck
} from "@mdi/js";
// const roles = localStorage.getItem('roles')
const menuHeadMaster = [
  {
    to: "/comboard-dashboard",
    icon: mdiViewDashboard,
    label: "sidebar.dashboard",
  },
  {
    label: "sidebarFin.students",
    subLabel: "Submenus Student",
    icon: mdiAccountCircle,
    menu: [
      {
        to: "/students",
        label: "sidebarFin.students",
        icon: mdiAccountGroup,
      },
      {
        to: '/non-academic-activity',
        label: 'sidebarFin.nonAcademicActivity',
        icon: mdiRunFast
      },
      {
        to: '/student-achievement',
        label: 'sidebarFin.studentAchievement',
        icon: mdiTrophyOutline
      }
      // {
      // 	to: '/student-doc',
      // 	label: 'Student Documents',
      // 	icon: mdiAccountGroup
      // },
      // {
      // 	to: '/parentuser',
      // 	label: 'Parents',
      // 	icon: mdiAccount
      // },
      // {
      // 	to: '/',
      // 	label: 'Users',
      // 	icon: mdiAccountMultiple
      // },
      // {
      // 	to: '/class-transfer',
      // 	label: 'Class Transfer',
      // 	icon: mdiAccountMultiplePlus
      // },
      // {
      // 	to: '/student-resignation',
      // 	label: 'Resignation',
      // 	icon: mdiAccountGroup
      // },
      // {
      // 	to: '/graduation',
      // 	label: 'Graduation',
      // 	icon: mdiAccountSchool
      // }
    ],
  },
  {
    label: 'sidebarFin.employee',
    subLabel: 'Employee',
    icon: mdiAccountCircle,
    menu: [
      {
        to: '/employee',
        label: 'sidebarFin.employee',
        icon: mdiAccount
      },
      {
        to: '/employee-daily-attendance',
        label: 'sidebarFin.employeeDailyAttendance',
        icon: mdiAccountCheck
      },
      {
        to: '/employee-special-assignments',
        label: 'sidebarFin.employeeSpecialAssignments',
        icon: mdiClipboardAccountOutline
      },
      {
        to: '/employee-attendance-report',
        label: 'sidebarFin.employeeAttendanceReport',
        icon: mdiAccountCheck
      }
    ]
  },
  {
    label: "sidebarFin.permissionRequest",
    subLabel: "Submenus Teacher",
    icon: mdiFaceAgent,
    menu: [
      {
        to: "/permissions",
        label: "sidebarFin.permissions",
        icon: mdiFaceAgent,
      },
      {
        to: "/permission-reason",
        label: "sidebarFin.permissionReason",
        icon: mdiFaceAgent,
      },
    ],
  },
  {
    label: "sidebarFin.attendance",
    subLabel: "Submenus Attendance",
    icon: mdiAccountArrowLeft,
    menu: [
      {
        to: "/daily-attendance",
        label: "sidebarFin.dailyAttendance",
        icon: mdiConsoleNetworkOutline,
      },
      {
        to: "/regular-subject-attendance",
        label: "sidebarFin.regularSubject",
        icon: mdiAccountArrowLeftOutline,
      },
      {
        to: "/parallel-subject",
        label: "sidebarFin.parallelSubject",
        icon: mdiAccountArrowLeftOutline,
      },
      {
        to: "/report-attendance-daily",
        label: "sidebarFin.reportAttendanceDaily",
        icon: mdiAccountAlert,
      },
      {
        to: "/assignment-special",
        label: "sidebarFin.specialAssignment",
        icon: mdiBusDoubleDecker,
      },
    ],
  },
  {
    label: "sidebarFin.schedule",
    subLabel: "Submenus Schedule",
    icon: mdiTimetable,
    menu: [
      // 	{
      // 	to: '/schooltime',
      // 	label: 'School Time',
      // 	icon: mdiAvTimer
      // },
      // {
      // 	to: '/studytime',
      // 	label: 'Study Time',
      // 	icon: mdiAvTimer
      // },
      {
        to: "/schedule",
        label: "sidebarFin.schedule",
        icon: mdiTimetable,
      },
      {
        to: "/extracuricular-schedule",
        label: "sidebarFin.extracuricularSchedule",
        icon: mdiTimetable,
      },
      {
        to: "/calendar",
        label: "sidebarFin.calendar",
        icon: mdiCalendarMonth,
      },
    ],
  },
  {
    label: "sidebarFin.subject",
    subLabel: "Submenus Subject",
    icon: mdiBookOpenVariant,
    menu: [
      {
        to: "/subject",
        label: "sidebarFin.subject",
        icon: mdiBookshelf,
      },
      {
        to: "/subject-group",
        label: "sidebarFin.subjectGroup",
        icon: mdiBookOpenPageVariant,
      },
      {
        to: "/learning-method",
        label: "sidebarFin.learningMethod",
        icon: mdiBookPlusMultiple,
      },
      {
        to: "/grading-aspects",
        label: "sidebarFin.gradingAspects",
        icon: mdiHammerScrewdriver,
      },
        {
        to: "/aspect-academic-year",
        label: "sidebarFin.aspectAcademicYear",
        icon: mdiCalendarMonth,
      },
      {
        to: "/aspect-assignment-level",
        label: "sidebarFin.aspectAssignmentLevel",
        icon: mdiClipboardText,
      },
      {
        to: "/assignment-type",
        label: "sidebarFin.assignmentType",
        icon: mdiFormatListBulletedType,
      },
      {
        to: "/grading-rule",
        label: "sidebarFin.gradingRule",
        icon: mdiFormatLetterMatches,
      },
      {
        to: "/final-score-rule",
        label: "sidebarFin.finalScoreRule",
        icon: mdiNumeric9BoxMultiple,
      },
      {
        to: "/scoreminimum",
        label: "sidebarFin.passingGrade",
        icon: mdiNumeric9BoxMultiple,
      },
      {
        to: "/syllabus",
        label: "sidebarFin.syllabus",
        icon: mdiNotebookEdit,
      },
      {
        to: "/teaching-time-plan",
        label: "sidebarFin.teachingTimePlan",
        icon: mdiTimelineClockOutline,
      },
      {
        to: "/lesson-plan",
        label: "sidebarFin.lessonPlan",
        icon: mdiPuzzle,
      },
      {
        to: "/student-paralel-subject",
        label: "sidebarFin.studentParallelSubject",
        icon: mdiAccountDetails,
      },
      {
        to: "/student-select-subject",
        label: "sidebarFin.studentSelectSubject",
        icon: mdiAccountDetails,
      },
    ],
  },
  {
    label: "sidebarFin.extracurricular",
    subLabel: "Submenus Extracuricular",
    icon: mdiSoccer,
    menu: [
      {
        to: "/extracuricular",
        label: "sidebarFin.extracurricular",
        icon: mdiSoccer,
      },
      {
        to: "/extracuricular-group",
        label: "sidebarFin.extracurricularGroup",
        icon: mdiSoccer,
      },
      {
        to: "/extracuricular-student",
        label: "sidebarFin.extracurricularStudent",
        icon: mdiAccountDetails,
      },
      {
        to: "/extracuricular-student-select",
        label: "sidebarFin.extracurricularStudentSelect",
        icon: mdiAccountDetails,
      },
      // {
      // 	to: '/extracuricularbarchart',
      // 	label: 'Report Extracuricular',
      // 	icon: mdiAccountDetails
      // }
    ],
  },
  {
    label: "sidebarFin.teacher",
    subLabel: "Submenus Teacher",
    icon: mdiClipboardAccount,
    menu: [
      {
        to: "/teacher",
        label: "sidebarFin.teacher",
        icon: mdiClipboardAccountOutline,
      },
      {
        to: "/teacher-extracuricular",
        label: "sidebarFin.teacherExtracuricular",
        icon: mdiSoccer,
      },
      {
        to: "/teacher-note",
        label: "sidebarFin.teacherNote",
        icon: mdiAccountDetails,
      },
      {
        to: "/scan-asset",
        label: "sidebarFin.scanAsset",
        icon: mdiQrcodeScan,
      },
      {
        to: "/scan-asset-location",
        label: "sidebarFin.scanAssetLocation",
        icon: mdiQrcodeScan,
      },
      // {
      // 	to: '/teacherjournal',
      // 	label: 'Teacher Journal',
      // 	icon: mdiFileDocument
      // }
    ],
  },
  {
    label: "sidebarFin.subjectAssessment",
    subLabel: "Submenus Subject Assessment",
    icon: mdiSchool,
    menu: [
      {
        to: "/lesson-assessment-regular",
        label: "sidebarFin.regular",
        icon: mdiSchool,
      },
      {
        to: "/lesson-assessment-parallel",
        label: "sidebarFin.parallel",
        icon: mdiSchool,
      },
      {
        to: '/ledger-homeroom-attidude',
        label: 'sidebarFin.ledgerHomeroomAttidude',
        icon: mdiSchool
      },
      {
        to: "/ledger-homeroom-teacher",
        label: "sidebarFin.ledgerHomeroomTeacher",
        icon: mdiSchool,
      },
      {
        to: "/extracuricular-score",
        label: "sidebarFin.extracuricularScore",
        icon: mdiSchool,
      },
    ],
  },
  {
    label: 'sidebarFin.report',
    to: '/student-raport',
    icon: mdiSchool
  },
];
export default menuHeadMaster;
